import { h, type FunctionalComponent } from 'vue'

export type ConsoleColor = 'accent' | 'good' | 'warn' | 'bad' | 'cyan' | 'violet' | 'muted'

type Props = { color?: ConsoleColor; size?: number | string }

// Functional: rendered once per row in lists, so it carries no instance state.
const StatusDot: FunctionalComponent<Props> = (props) => {
  // Callers pass both 8 and "8px".
  const size = `${Number.parseFloat(String(props.size ?? 7))}px`
  return h('span', {
    style: {
      width: size,
      height: size,
      borderRadius: '9999px',
      background: `var(--${props.color ?? 'good'})`,
      display: 'inline-block',
      flexShrink: 0,
    },
  })
}

StatusDot.props = ['color', 'size']

export default StatusDot
